import { render, staticRenderFns } from "./technicist.vue?vue&type=template&id=455392b8&scoped=true&"
import script from "./technicist.vue?vue&type=script&lang=js&"
export * from "./technicist.vue?vue&type=script&lang=js&"
import style0 from "./technicist.vue?vue&type=style&index=0&id=455392b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455392b8",
  null
  
)

export default component.exports